import axios from 'axios';

export default ({ id, address }) => {
  const preparedData = {
    address,
  };

  return axios.patch(`${process.env.VUE_APP_API_ENDPOINT}/buildings/${id}`, { ...preparedData });
};
